// @flow

import React, { type Node } from 'react';
import styled from 'styled-components';
import { useIncomingPayment, isRetry } from '@tectonics/prs/incoming-payment';
import { useSubmitError } from '@tectonics/prs/validation';
import { Greeting } from './greeting';
import { FinishMessage } from './finish-message';
import { Form } from './form';
import { TermsMessage } from './terms';
import { Retry } from './retry';
import { SubmitErrorDisplay } from './submit-error-display';

type Props = {|
  onSubmit: (boolean, boolean) => Promise<boolean>,
|};

export function Main({ onSubmit }: Props): Node  {
  const incomingPayment = useIncomingPayment();
  const retry = isRetry(incomingPayment);
  const submitError = useSubmitError();

  return (
    <Root data-test-id="page-opened-payment">
      <Header>
        {retry && (
          <Retry />
        )}

        {submitError && (
          <SubmitErrorDisplay submitError={submitError} />
        )}

        <Greeting />
        <FinishMessage />
      </Header>
      <Content>
        <Form onSubmit={onSubmit} />
      </Content>
      <Footer>
        <TermsMessage/>
      </Footer>
    </Root>
  );
}

const Header = styled.header`
  grid-area: header;
  display: grid;
  grid-gap: 10px;
  padding: 15px 0;
`;

const Content = styled.main`
  grid-area: content;
`;

const Footer = styled.footer`
  grid-area: footer;
`;

const Root = styled.div`
  margin: 15px 0;
  display: grid;
  grid-row-gap: 20px;
  grid-template-columns: 15px 1fr 15px;
  grid-template-rows: auto;
  grid-template-areas:
    ". header ."
    "content content content"
    ". footer .";

  @media (min-width: 990px) {
    grid-template-areas:
      "header header header"
      "content content content"
      "footer footer footer";
  }
`;
